export default function flattenArray(array, initialValue = []) {
  if (!(array instanceof Array)) {
    throw new Error(`You must pass an array to flattenArray; you passed ${String(array)}.`);
  }

  return array.reduce((accumulator, currentValue) => {
    return accumulator.concat(currentValue instanceof Array ? flattenArray(currentValue) : currentValue);
  }, initialValue);
}
